// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__o8Ojs","redirectLogin":"login_redirectLogin__or2hp"};